import { FC } from 'react'

import { Row } from 'sections/articles/content-components/row'
import { TextOnly } from 'sections/articles/content-components/text-only'
import { ComponentTextAndTextModel } from 'api'

interface TextAndTextProps {
  data: ComponentTextAndTextModel
}

export const TextAndText: FC<TextAndTextProps> = ({ data }) => {
  return (
    <Row {...data}>
      <TextOnly data={data.first_section} />
      <TextOnly data={data.second_section} />
    </Row>
  )
}
